import React from 'react';
import {
  FDContentContainer, FDStack,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { PageSubmitButton } from 'Views/Page/Components/PageSubmitButton/PageSubmitButton';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { WizardLayout } from 'Views/Page/Content/Templates/WizardTemplates/EstatePlanningRecommendation/Components';

export const EstatePlanningRecommendationQuizRecommendationStepLayout = () => {
  const { pageContentResource } = usePageContentContext();

  return (
    <WizardLayout
      description={<MetaControlField attr={'recommendationRationale'} />}
    >
      <FDContentContainer maxWidth={'lg'}>
        <FDStack direction={'column'} spacing={8} alignItems={'center'} paddingY={2}>
          <MetaControlField attr={'customDocument'} />
          <MetaControlField attr={'products'} />
          <PageSubmitButton resource={pageContentResource} />
        </FDStack>
      </FDContentContainer>
    </WizardLayout>);
};
